import { useEffect, useState } from "react";

import StepsHeader from "./utils/stepsHeader";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./trackInvoice.css";
import BasicPanel from "../../components/panels/basicPanel/basicPanel";

const N_SVG = 
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.40625 7.5H17.5" stroke="url(#paint0_linear_1_1866)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.75 3.125L11.25 16.875" stroke="url(#paint1_linear_1_1866)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.75 3.125L6.25 16.875" stroke="url(#paint2_linear_1_1866)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.5 12.5H16.5937" stroke="url(#paint3_linear_1_1866)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<defs>
<linearGradient id="paint0_linear_1_1866" x1="3.40625" y1="8" x2="17.5" y2="8" gradientUnits="userSpaceOnUse">
<stop stop-color="#55E5FF"/>
<stop offset="1" stop-color="#5DFF66"/>
</linearGradient>
<linearGradient id="paint1_linear_1_1866" x1="11.25" y1="10" x2="13.75" y2="10" gradientUnits="userSpaceOnUse">
<stop stop-color="#55E5FF"/>
<stop offset="1" stop-color="#5DFF66"/>
</linearGradient>
<linearGradient id="paint2_linear_1_1866" x1="6.25" y1="10" x2="8.75" y2="10" gradientUnits="userSpaceOnUse">
<stop stop-color="#55E5FF"/>
<stop offset="1" stop-color="#5DFF66"/>
</linearGradient>
<linearGradient id="paint3_linear_1_1866" x1="2.5" y1="13" x2="16.5938" y2="13" gradientUnits="userSpaceOnUse">
<stop stop-color="#55E5FF"/>
<stop offset="1" stop-color="#5DFF66"/>
</linearGradient>
</defs>
</svg>

const B_SVG =
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 11.875H12.5" stroke="url(#paint0_linear_1_1881)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.5 9.375H12.5" stroke="url(#paint1_linear_1_1881)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.5 3.125H15.625C15.7908 3.125 15.9497 3.19085 16.0669 3.30806C16.1842 3.42527 16.25 3.58424 16.25 3.75V16.875C16.25 17.0408 16.1842 17.1997 16.0669 17.3169C15.9497 17.4342 15.7908 17.5 15.625 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.75C3.75 3.58424 3.81585 3.42527 3.93306 3.30806C4.05027 3.19085 4.20924 3.125 4.375 3.125H7.5" stroke="url(#paint2_linear_1_1881)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.875 5.625V5C6.875 4.1712 7.20424 3.37634 7.79029 2.79029C8.37634 2.20424 9.1712 1.875 10 1.875C10.8288 1.875 11.6237 2.20424 12.2097 2.79029C12.7958 3.37634 13.125 4.1712 13.125 5V5.625H6.875Z" stroke="url(#paint3_linear_1_1881)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<defs>
<linearGradient id="paint0_linear_1_1881" x1="7.5" y1="12.375" x2="12.5" y2="12.375" gradientUnits="userSpaceOnUse">
<stop stop-color="#55E5FF"/>
<stop offset="1" stop-color="#5DFF66"/>
</linearGradient>
<linearGradient id="paint1_linear_1_1881" x1="7.5" y1="9.875" x2="12.5" y2="9.875" gradientUnits="userSpaceOnUse">
<stop stop-color="#55E5FF"/>
<stop offset="1" stop-color="#5DFF66"/>
</linearGradient>
<linearGradient id="paint2_linear_1_1881" x1="3.75" y1="10.3125" x2="16.25" y2="10.3125" gradientUnits="userSpaceOnUse">
<stop stop-color="#55E5FF"/>
<stop offset="1" stop-color="#5DFF66"/>
</linearGradient>
<linearGradient id="paint3_linear_1_1881" x1="6.875" y1="3.75" x2="13.125" y2="3.75" gradientUnits="userSpaceOnUse">
<stop stop-color="#55E5FF"/>
<stop offset="1" stop-color="#5DFF66"/>
</linearGradient>
</defs>
</svg>

const SVG_ARROW =
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.36346 2.29767C5.71493 1.93359 6.28478 1.93359 6.63625 2.29767L12.6362 8.51302C12.9877 8.87711 12.9877 9.46741 12.6362 9.83149L6.96958 15.7015C6.61811 16.0656 6.04826 16.0656 5.69679 15.7015C5.34532 15.3375 5.34532 14.7472 5.69679 14.3831L10.7271 9.17226L5.36346 3.61615C5.01198 3.25206 5.01198 2.66176 5.36346 2.29767Z" fill="#17C653"/>
</svg>




export default function TrackInvoice() {
    const navigator = useNavigate();
    const { t } = useTranslation('basic');

    return (
        <div className="trackInvoice">
            <StepsHeader />
            <div className="basicWrapperPadding">
                <span className="paragraph-16M">{t("select_tracking_option")}</span>
                <div className="trackInvoiceVariants">
                    <BasicPanel onClick={() => navigator("/tracking_by_number")}>
                        <div className="trackInvoiceVariant">
                            <div className="trackInvoiceVariantLeft">
                                <span className="aligned">{N_SVG}</span>
                                <span className="paragraph-14R">{t("by_package_number")}</span>
                            </div>
                            <div className="trackInvoiceVariantRight">
                                <span className="aligned">{SVG_ARROW}</span>
                            </div>
                        </div>
                    </BasicPanel>
                    <BasicPanel onClick={() => navigator("/tracking_from_bot")}>
                        <div className="trackInvoiceVariant">
                            <div className="trackInvoiceVariantLeft">
                                <span className="aligned">{N_SVG}</span>
                                <span className="paragraph-14R">{t("invoice_created_in_assistant")}</span>
                            </div>
                            <div className="trackInvoiceVariantRight">
                                <span className="aligned">{SVG_ARROW}</span>
                            </div>
                        </div>
                    </BasicPanel>
                </div>
            </div>
        </div>
    )
}